define.alias("shared/components/shared/ui/cluster-switcher", "media/components/shared/ui/cluster-switcher");